module.exports = __webpack_public_path__ + "media/images/icons/footer-icon-facebook-hover-d788c45bd5121de43205704f3d1de385.png";